/** Full admin access: all menus and routes */
export const FULL_ACCESS_ROLE_ID = 8;

/**
 * Route names allowed when role_id is not {@link FULL_ACCESS_ROLE_ID}.
 * Dashboard, Work Management (Works only in the menu), and Settings.
 * Enquiries, Work Requests, Cancellation Requests, and Company Titles are role 8 only.
 */
export const LIMITED_USER_ALLOWED_ROUTE_NAMES = new Set([
  'defaultRoot',
  'dashboard',
  'job_management',
  // 'enquiry_list',
  // 'enquiry_details',
  'create_job',
  'update_job',
  'job_details',
  'mark_complete',
  'job_logs',
  'generate_device_certificate',
  'update_certificate',
  'settings',
]);

/** Sub-items under "Work Management" visible to non–role-8 users (menu titles in `data/menu.js`). */
// export const LIMITED_WORK_MANAGEMENT_CHILD_TITLES = new Set(['Works', 'Enquiries']);
export const LIMITED_WORK_MANAGEMENT_CHILD_TITLES = new Set(['Works']);